import { MxBaseMask } from './mx-mask-base';

export class MxNumericMask extends MxBaseMask {
	constructor(decimalDigit, noFormat, isNegative, type) {
		super();
		this.decimalDigit = typeof decimalDigit === 'object' ? decimalDigit[0] : decimalDigit || 0;
		this.noFormat = typeof decimalDigit === 'object' ? decimalDigit[1] : noFormat || false;
		this.isNegative = typeof decimalDigit === 'object' ? decimalDigit[2] : isNegative || false;
		this.type = typeof decimalDigit === 'object' ? decimalDigit[3] : type || undefined;
	}
	createFormatter(ngModel) {
		return function (value) {
			const availableRegex = new RegExp('[^0-9' + (this.isNegative ? '-' : '') + ']', 'g');

			const actualValue = this.clearFloatingPart(value).replace(availableRegex, this.decimalDigit > 0 ? this.localeFormats.DECIMAL_SEP : '');
			const isReadonly = ngModel.$$lastCommittedViewValue === undefined || ngModel.$$updateEvents === 'blur';
			return this.applyFormat(actualValue, isReadonly) || actualValue;
		};
	}
	createParser() {
		return function (value) {
			return this.getNumber(value, true);
		};
	}

	initialize(options) {
		let pattern = '0999999999999',
			availableSymbols = '.'; // should add server decimalSymbol
		this.originalFormat = '###';

		if (this.decimalDigit > 0) {
			pattern += this.localeFormats.DECIMAL_SEP + this._repeat('9', this.decimalDigit);
			availableSymbols += this.localeFormats.DECIMAL_SEP;
			this.originalFormat += '.[' + this._repeat('#', this.decimalDigit) + ']';
		}
		if (!this.noFormat) {
			availableSymbols += this.localeFormats.GROUP_SEP;
		}
		if (this.isNegative) {
			pattern = '-' + pattern;
			this.originalFormat = '-' + this.originalFormat;
			availableSymbols += '-';
		}

		this.groupRegex = new RegExp(this.escapeRegex(this.localeFormats.GROUP_SEP), 'g');
		this.decimalRegex = new RegExp(this.escapeRegex(this.localeFormats.DECIMAL_SEP), 'g');
		this.clearRegex = new RegExp('[^0-9' + availableSymbols + ']', 'g');

		Object.assign(options, { reverse: false });
		delete options.onChange;
		this.viewMask = this.createMask(pattern, options);
	}

	focus(ngModel) {
		if (ngModel.$viewValue) {
			const viewValue = this.applyFormat(ngModel.$viewValue.toString(), false) || ngModel.$viewValue.toString();
			ngModel.$setViewValue(viewValue.replace(this.clearRegex, ''));
			ngModel.$render();
		}
	}

	blur(ngModel) {
		if (ngModel.$viewValue) {
			const viewValue = this.applyFormat(ngModel.$viewValue.toString(), true, true) || ngModel.$viewValue.toString();
			ngModel.$setViewValue(viewValue.replace(this.clearRegex, ''));
			ngModel.$render();
		}
	}

	getNumber(value, editedByUser) {
		let res;
		if (this.decimalDigit > 0) {
			res = this.disableFormating(value).replace(this.decimalRegex, '.');
			if (editedByUser) {
				// Let's say value is `1.99`, cursor is in the end and user press '9'
				// so we expect not to change value `1.99` and leave as it is, instead of rounding it to `2.00`.
				// Showing rounded value without changing the model is ok on init or when value are set via calc-field, like it was before.
				const dotPosition = res.indexOf('.');
				if (dotPosition !== -1) {
					res = res.slice(0, dotPosition + this.decimalDigit + 1);
				}
			}
			res = parseFloat(res);
		} else {
			res = parseInt(this.disableFormating(value).replace(this.decimalRegex, ''));
		}
		return res;
	}

	disableFormating(value) {
		return value.toString().replace(this.groupRegex, '');
	}
	applyFormat(value, isReadonly, editedByUser) {
		if (value && value.replace(this.clearRegex, '')) {
			if (isReadonly) {
				let result =
					this.type === 'currency'
						? this.i18n.formatCurrency(this.getNumber(value, editedByUser))
						: this.i18n.formatNumber(this.getNumber(value, editedByUser), this.type, this.originalFormat);
				if (!result) {
					return result;
				}
				result = this.clearFloatingPart(result);

				if (!isReadonly || this.noFormat) {
					result = this.disableFormating(result);
				}

				return result.replace(this.clearRegex, '');
			}

			return this.disableFormating(value);
		}

		return null;
	}

	clearFloatingPart(result) {
		const decimalIndex = result.toString().indexOf(this.localeFormats.DECIMAL_SEP);
		if (this.decimalDigit === 0 && decimalIndex !== -1) {
			result = result.toString().substring(0, decimalIndex);
		}

		return result.toString();
	}

	escapeRegex(s) {
		return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
	}

	_repeat(str, times) {
		return new Array(times + 1).join(str);
	}
}
